import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui/Button';

export function UserMenu() {
  const { email, signOut } = useAuth();

  return (
    <div className="flex items-center gap-3">
      {email && (
        <span className="hidden text-sm text-gray-600 sm:inline" title={email}>
          {email}
        </span>
      )}
      <Button variant="secondary" size="sm" onClick={() => void signOut()}>
        Sign out
      </Button>
    </div>
  );
}
